import React, { Fragment, useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { connect } from "react-redux";
import Spinner from "../Spinner";
import Footer from "./Footer";
import { changePassword } from "../../../actions/auth";
import swal from "sweetalert";
import { logout } from "../../../actions/auth";
const ChangePassword = ({ auth: { loading }, changePassword, logout }) => {
  const [formDataa, setFormData] = useState({
    previous_password: "",
    new_password: "",
    confirm_password: "",
  });
  const [previousPasswordValidationError, setPreviousPasswordValidationError] =
    useState("");
  const [newPasswordValidationError, setNewPasswordValidationError] =
    useState("");
  const [confirmPasswordValidationError, setConfirmPasswordValidationError] =
    useState("");
  const { previous_password, new_password, confirm_password } = formDataa;
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [successMessage, setSuccessMessage] = useState("Saved");

  const [hide, sethide] = useState("password");
  const [eye_toggle, seteyetoggle] = useState(
    <i className="fas fa-eye-slash align-middle"></i>
  );

  const [hidee, sethidee] = useState("password");
  const [eye_togglee, seteyetogglee] = useState(
    <i className="fas fa-eye-slash align-middle"></i>
  );

  const [hide3, sethide3] = useState("password");
  const [eye_toggle3, seteyetoggle3] = useState(
    <i className="fas fa-eye-slash align-middle"></i>
  );

  const [buttonClass, setButtonClass] = useState("btn btn-primary");
  const onkeyUp = (e) => {
    setSuccessMessage("Save Changes");
    setButtonClass("btn btn-secondary");
    switch (e.target.id) {
      case "previous_password":
        if (e.target.value == "") {
          setPreviousPasswordValidationError(
            "Please enter your current password."
          );
        } else if (e.target.value.length < 8) {
          setPreviousPasswordValidationError(
            "Password must be at least 8 characters long."
          );
        } else {
          setPreviousPasswordValidationError("");
        }
        break;
      case "new_password":
        if (e.target.value == "") {
          setNewPasswordValidationError("Please enter a new password.");
        } else if (e.target.value.length < 8) {
          setNewPasswordValidationError(
            "New password must be at least 8 characters long."
          );
        } else {
          setNewPasswordValidationError("");
        }
        break;
      case "confirm_password":
        if (e.target.value == "") {
          setConfirmPasswordValidationError("Please enter a confirm password.");
        } else if (e.target.value.length < 8) {
          setConfirmPasswordValidationError(
            "Confirm password must be at least 8 characters long."
          );
        } else {
          setConfirmPasswordValidationError("");
        }
        break;
      default:
        return "";
    }
  };
  const onChange = (e) => {
    setFormData({ ...formDataa, [e.target.name]: e.target.value.trimStart() });
  };
  const toggle_password = () => {
    if (hide == "password") {
      seteyetoggle(<i className="fas fa-eye align-middle"></i>);
      sethide("text");
    } else {
      seteyetoggle(<i className="fas fa-eye-slash align-middle"></i>);
      sethide("password");
    }
  };

  const toggle_password2 = () => {
    if (hidee == "password") {
      seteyetogglee(<i className="fas fa-eye align-middle"></i>);
      sethidee("text");
    } else {
      seteyetogglee(<i className="fas fa-eye-slash align-middle"></i>);
      sethidee("password");
    }
  };

  const toggle_password3 = () => {
    if (hide3 == "password") {
      seteyetoggle3(<i className="fas fa-eye align-middle"></i>);
      sethide3("text");
    } else {
      seteyetoggle3(<i className="fas fa-eye-slash align-middle"></i>);
      sethide3("password");
    }
  };

  const onSubmit = async (e) => {
    setPreviousPasswordValidationError("");
    setConfirmPasswordValidationError("");
    setNewPasswordValidationError("");
    e.preventDefault();

    formDataa.previous_password = e.target.previous_password.value;
    formDataa.new_password = e.target.new_password.value;

    formDataa.confirm_password = e.target.confirm_password.value;
    if (formDataa.previous_password == "") {
      setPreviousPasswordValidationError("Please enter your current password.");
    }
    if (formDataa.new_password == "") {
      setNewPasswordValidationError("Please enter a new password.");
    }
    if (formDataa.confirm_password == "") {
      setConfirmPasswordValidationError("Please enter a confirm password.");
    }
    if (
      formDataa.previous_password != "" &&
      formDataa.new_password != "" &&
      formDataa.confirm_password != ""
    ) {
      console.log(formDataa);
      changePassword(formDataa)
        .then((PromiseValue) => {
          if (PromiseValue.message) {
            setSuccessMessage("Saved");
            setButtonClass("btn btn-success");
            swal(
              "",
              "Your password has been changed successfully.",
              "success"
            ).then(() => {
              logout();
              // window.location.href = "/admin-login";
            });
          }
          PromiseValue.forEach((element) => {
            if (element.param == "previous_password") {
              setPreviousPasswordValidationError(element.msg);
            }
            if (element.param == "new_password") {
              setNewPasswordValidationError(element.msg);
            }
            if (element.param == "confirm_password") {
              setConfirmPasswordValidationError(element.msg);
            }
          });
        })
        .catch((error) => console.log(error));
    }
  };
  return loading ? (
    <Spinner />
  ) : (
    <div id="wrapper">
      <Sidebar />
      {/* Content Wrapper */}
      <div id="content-wrapper" className="d-flex flex-column">
        {/* Main Content */}
        <div id="content">
          <Header />
          {/* Begin Page Content */}
          <div className="container-fluid">
            {/* Page Heading */}
            <div className="col-lg-12 mb-4">
              {/* Illustrations */}
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    Change Password
                  </h6>
                </div>
                <div className="card-body">
                  <div className="col mr-2">
                    <form
                      className="form-horizontal"
                      onSubmit={(e) => onSubmit(e)}
                      encType="multipart/form-data"
                      noValidate
                    >
                      <div className="row">
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label htmlFor="previous_password">
                              Current Password :{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <div className="form-group password-input-new">
                              <input
                                type={hidee}
                                name="previous_password"
                                className="form-control required "
                                placeholder="Enter Your Current Password"
                                id="previous_password"
                                onChange={(e) => onChange(e)}
                                value={previous_password}
                                maxLength={16}
                                onKeyUp={(e) => onkeyUp(e)}
                              />
                              <button
                                type="button"
                                id="button-addon2"
                                className="eye-icon-btn-new"
                                onClick={toggle_password2}
                              >
                                {eye_togglee}
                              </button>
                              {previousPasswordValidationError != "" ? (
                                <div className="help-block font-small-3">
                                  <p className="text-danger">
                                    {previousPasswordValidationError}
                                  </p>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label htmlFor="new_password">
                              New Password :{" "}
                              <span className="text-danger">*</span>
                            </label>

                            <div className="form-group password-input-new">
                              <input
                                type={hide}
                                name="new_password"
                                className="form-control required"
                                placeholder="Enter Your New Password"
                                id="new_password"
                                maxLength={16}
                                onChange={(e) => onChange(e)}
                                onKeyUp={(e) => onkeyUp(e)}
                              />

                              <button
                                type="button"
                                id="button-addon2"
                                className="eye-icon-btn-new"
                                onClick={toggle_password}
                              >
                                {eye_toggle}
                              </button>
                              {newPasswordValidationError != "" ? (
                                <div className="help-block font-small-3">
                                  <p className="text-danger">
                                    {newPasswordValidationError}
                                  </p>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label htmlFor="confirm_password">
                              Confirm New Password :{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <div className="form-group password-input-new">
                              <input
                                type={hide3}
                                name="confirm_password"
                                id="confirm_password"
                                className="form-control"
                                placeholder="Enter Your Confirm New Password"
                                onChange={(e) => onChange(e)}
                                onKeyUp={(e) => onkeyUp(e)}
                                maxLength={16}
                                value={confirm_password}
                              />

                              <button
                                type="button"
                                id="button-addon2"
                                className="eye-icon-btn-new"
                                onClick={toggle_password3}
                              >
                                {eye_toggle3}
                              </button>

                              {confirmPasswordValidationError != "" ? (
                                <div className="help-block font-small-3">
                                  <p className="text-danger">
                                    {confirmPasswordValidationError}
                                  </p>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          <div className="text-right">
                            {!previousPasswordValidationError &&
                            !newPasswordValidationError &&
                            !confirmPasswordValidationError ? (
                              <button type="submit" className={buttonClass}>
                                {successMessage}
                              </button>
                            ) : (
                              <button
                                type="submit"
                                className={buttonClass}
                                disabled
                              >
                                {successMessage}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </div>
        {/* End of Main Content */}
        {/* Footer */}
        <Footer />
        {/* End of Footer */}
      </div>
      {/* End of Content Wrapper */}
    </div>
  );
};
const mapStateToProps = (state) => ({
  auth: state.auth,
});
export default connect(mapStateToProps, { changePassword, logout })(
  ChangePassword
);
